var _module = require('../../components/module');
var _ = require('lodash');
var $ = require('jquery');

require('../lr-touch');
require('../../filters');
require('angular-ui-bootstrap/src/modal');
require('../../components/window-height');
require('../user');
require('../search-filter-params');
require('../mortgage-calculator-store');

_module.requires.push('ui.bootstrap.module.modal');

_module.service('$editFilterModal', [
    '$log',
    '$uibModal',
    '$timeout',
    '$user',
    'searchFilterParams',
    '$mortgageCalculatorStore',

    function $editFilterModalService($log, $uibModal, $timeout, $user, searchFilterParams, $mortgageCalculatorStore) {
        /*
        @function openEditFilterModal
        */
        return function openEditFilterModal(sfilter, operation, newKeyword, newLatLng) {
            var modal = $uibModal.open({
                template: require('./index.html'),
                controller: ['$scope', function openEditFilterModal($scope) {
                    var initPriceSlider = function () {
                        $scope.priceslider = {};
                        $scope.priceslider.min = 0;
                        $scope.priceslider.max = 2000000;
                        $scope.priceslider.price = 1000000;
                        $scope.priceslider.percent = 50;
                        $scope.priceslider.showMonthlyPayment = false;
                        $scope.priceslider.sliderOptions = {
                            floor: parseInt($scope.priceslider.min),
                            ceil: parseInt($scope.priceslider.max)
                        };

                        // Functions
                        $scope.priceslider.onDrag = function onDrag(e) {
                            var value = Math.round(e.percentX * 100) / 100 * $scope.priceslider.max;

                            if(value !== $scope.priceslider.price) {
                                $scope.priceslider.price = value;
                                $scope.priceslider.percent = e.percentX * 100;
                                //$scope.priceSlider.onUpdate({ $value: value });
                            }
                        };

                        $scope.priceslider.calculateMonthlyPayment = function calculateMonthlyPayment() {
                            var principal = $scope.priceslider.price * 0.8;
                            var interest = $mortgageCalculatorStore.interest_rates['30'];
                            var numPayments = 30 * 12;

                            return $mortgageCalculatorStore.calculatePrincipalAndInterestPayment(principal, interest, numPayments);
                        };
                    };

                    $scope.getDecimialPlace = function getDecimialPlace() {
                        return $scope.priceslider.price < 1000000 ? 0 : 2;
                    };

                    $scope.initAutoComplete = function () {
                        var input = document.getElementById('edit-filter-location');
                        var autocomplete = new google.maps.places.Autocomplete(input, {
                            type: '(regions)',
                            componentRestrictions: { country: 'us' }
                        });

                        $scope.keyword = $scope.keyword || '';
                        $scope.latLng = [];

                        // Listeners
                        google.maps.event.addListener(autocomplete, 'place_changed', function placeChanged(e) {
                            var place = autocomplete.getPlace();
                            var keyword = place.name || $scope.keyword || '';

                            if(place.formatted_address) {
                                keyword = place.formatted_address.replace(/, (usa|united states)/gi, '');
                                $scope.latLng = [place.geometry.location.lat(), place.geometry.location.lng()];
                            }

                            if(place.address_components &&
                                angular.isArray(place.address_components) &&
                                place.address_components.length){

                                var city = '';
                                var state = '';
                                var keymap = {
                                    locality: 'long_name',
                                    administrative_area_level_1: 'short_name'
                                };

                                angular.forEach(place.address_components, function (comp, i) {
                                    var compType = comp.types[0];
                                    if(keymap[compType]){
                                        switch(compType){
                                            case 'locality':
                                                city = comp[keymap[compType]];
                                                break;
                                            case 'administrative_area_level_1':
                                                state = comp[keymap[compType]];
                                                break;
                                            default: break;
                                        }
                                    }
                                });

                                if(city.length > 0 || state.length > 0){
                                    keyword = [city,', ', state].join('');
                                }

                            }
                            $timeout(function () {
                                $scope.keyword = keyword;
                            }, 10);
                        });
                    };

                    $scope.getBasicFilterCount = function () {
                        var r = $scope.possibleParams.filter(function (param) { return !!param.selected; });
                        var count = parseInt(r.length + 1, 10); // adding 1 to the count because price is always a param
                        $scope.ui.basicFilterCompleteCount = count;
                    };

                    var keywordsMatchListDirtyCheck = function () {
                        var inputEl = $('.md-chips .md-input');
                        if(inputEl) {
                            var dirtyValue = inputEl.val();
                            if(dirtyValue && dirtyValue.length > 1 && $scope.keywordsMatchList.indexOf(dirtyValue) < 0) {
                                inputEl.val('');
                                $scope.keywordsMatchList.push(dirtyValue);
                            }
                        }
                    };

                    var updateFilterParams = function () {
                        $scope.sfilter.params = $scope.sfilter.params || [];
                        var newParams = [{'name':'price', 'value':$scope.priceslider.price}];
                        angular.forEach($scope.possibleParams, function (param, i) {
                            if(param.selected !== null){
                                newParams.push({
                                    'name':param.id,
                                    'value':param.selected
                                });
                            }
                        }, $scope.possibleParams);

                        keywordsMatchListDirtyCheck();

                        if( $scope.keywordsMatchList &&
                            angular.isArray($scope.keywordsMatchList) &&
                            $scope.keywordsMatchList.length > 0 ) {

                            newParams.push({
                                name: 'keywords',
                                value: $scope.keywordsMatchList
                            });
                        }

                        $scope.sfilter.params = newParams;
                    };

                    var getUniqueFilterName = function (filterName) {
                        var r = filterName || '';
                        var noTrailingDigits = r.trim().replace(/\d+$/, '').trim();
                        if($user && $user.filters) {
                            var fltrs = $user.filters.filter(function (f, i) {
                                return !!f.name.match(noTrailingDigits);
                            });
                            var suffix = '';
                            if(fltrs.length > 0){
                                suffix += ' ';
                                suffix += parseInt(fltrs.length + 1, 10);
                            }

                            r = noTrailingDigits + suffix;
                        }

                        return r;
                    };

                    var getFilter = function () {
                        var fltr = sfilter || {};
                        if($scope.operation == 'new') {
                            fltr.search_term = newKeyword;
                            fltr.name = getUniqueFilterName(['My ', newKeyword, ' Homes'].join(''));
                            $scope.latLng = newKeyword;
                        }

                        if($scope.operation == 'duplicate') {
                            fltr.name = getUniqueFilterName(sfilter.name);
                        }
                        return JSON.parse(JSON.stringify(fltr));
                    };

                    var getPossibleParams = function (operation) {
                        var getParamValue = function (param) {
                            var val = _.find($scope.sfilter.params, {'name': param.id});
                            return (!!val)
                                ? val.value
                                : null;
                        };

                        var getParamTitle = function (param, optionId) {
                            var selectedOption = _.find(param.values, {'id': optionId});
                            return (!!selectedOption)
                                ? selectedOption.title
                                : null;
                        };

                        var getSelectedPrice = function () {
                            return _.find($scope.sfilter.params, {'name': 'price'});
                        };

                        var prefill = function (possibleParams) {
                            if (
                                ['edit', 'duplicate'].indexOf(operation) > -1 &&
                                $scope.sfilter &&
                                $scope.sfilter.params &&
                                angular.isArray($scope.sfilter.params) &&
                                possibleParams &&
                                angular.isArray(possibleParams)
                            ){
                                angular.forEach(possibleParams, function (param, i) {
                                    param.selected = getParamValue(param);
                                    param.selectedTitle = getParamTitle(param, param.selected);
                                },possibleParams);

                                var selectedPrice = getSelectedPrice();
                                if(selectedPrice && !isNaN(selectedPrice.value)) {
                                    $scope.priceslider.price = parseInt(selectedPrice.value,10);
                                    $scope.priceslider.percent = ( $scope.priceslider.price / $scope.priceslider.max ) * 100;
                                }
                            }

                            /*
                            We need to filter out `2-3` and `Any` if the selected
                            value doesn't exist or if the user has not selected
                            a `2-3`.
                            */
                            var bedrooms = _.find(possibleParams, { id: 'bedrooms' });
                            if(bedrooms.selected !== '2-3') {
                                bedrooms.values = bedrooms.values.filter(function (value) {
                                    return !value.needs23Value;
                                });
                            }
                        };

                        var possibleParams = searchFilterParams.get();
                        prefill(possibleParams);

                        return possibleParams;

                    };

                    var getUiFlags = function () {
                        return {
                            showBasicFilters: ['edit', 'new'].indexOf(operation) > -1,
                            basicFilterCompleteCount: 1,
                            showBasicFilterDropdown: {}
                        };
                    };

                    var getKeywordsMatchList = function getKeywordsMatchList (sfilter) {
                        var kwList = [];
                        if(sfilter && sfilter.params) {
                            var found = _.find(sfilter.params, {name: 'keywords'});
                            if(found && found.value && angular.isArray(found.value)) {
                                kwList = _.concat(kwList, found.value);
                            }
                        }
                        return kwList;
                    };

                    var init = function () {
                        $scope.operation = operation;
                        $scope.ui = getUiFlags();
                        $scope.sfilter = getFilter();
                        $scope.keyword = $scope.sfilter.search_term;
                        initPriceSlider();
                        $scope.keywordsMatchList = getKeywordsMatchList($scope.sfilter);
                        $scope.possibleParams = getPossibleParams(operation);
                        $scope.getBasicFilterCount();

                        /*$timeout(function () {
                            $scope.initAutoComplete();
                        }, 200);*/
                    };

                    init();

                    $scope.toggleBasicFilterDropdown = function (id) {
                        if($scope.ui && $scope.ui.showBasicFilterDropdown) {
                            if($scope.ui.showBasicFilterDropdown.hasOwnProperty(id)) {
                                $scope.ui.showBasicFilterDropdown[id] = !$scope.ui.showBasicFilterDropdown[id];
                            } else {
                                $scope.ui.showBasicFilterDropdown[id] = true;
                            }
                        }
                    };

                    $scope.selectBasicFilterParameter = function (paramId, optionId) {
                        var currentParam = _.findIndex($scope.possibleParams, {'id': paramId});
                        if(optionId &&
                            !isNaN(currentParam) &&
                            currentParam > -1 &&
                            $scope.possibleParams[currentParam].values) {
                            var selectedOption = _.find($scope.possibleParams[currentParam].values, {'id': optionId});

                            if(selectedOption) {
                                $scope.possibleParams[currentParam].selected = selectedOption.id;
                                $scope.possibleParams[currentParam].selectedTitle = selectedOption.title;
                                $scope.toggleBasicFilterDropdown(paramId);
                            }
                        }
                    };

                    $scope.updateFilter = function () {
                        updateFilterParams();
                        $scope.sfilter.search_term = $scope.keyword;
                        return JSON.parse(JSON.stringify($scope.sfilter));
                    };


                    // WATCHERS

                    $scope.$watch(function () { return $mortgageCalculatorStore.loading; }, function (value) {
                        if(!value && $mortgageCalculatorStore.interest_rates['30']) {
                            $scope.priceslider.showMonthlyPayment = true;
                        }
                    });

                }],
                backdrop: 'static',
                keyboard: false,
                windowClass: 'edit-filter-modal'
            });

            return modal.result;
        };
    }
]);
